<script>
export default {
  components: {},
  props: {
    content: {
      type: String,
      required: true,
      default: null
    },
    title: {
      type: String,
      required: true,
      default: null
    },
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<template>
  <div class="base-content-block">
    <h5 v-if="title">{{ title }}</h5>
    <p v-if="content">{{ content }}</p>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.base-content-block {
  padding: 0 2.5rem 2.5rem;
}
</style>
